import { Component, Input, OnDestroy } from '@angular/core';
import { ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { SubmissionService } from '../../http/intake/submission.service';
import { Subject, takeUntil } from 'rxjs';
import { DocumentService } from '../../http/document/document.service';
import {
  Column,
  DocumentTableData,
  sampleColumns,
} from './export-pdf-popup-component-helper';
import {
  ButtonKind,
  ExtThemes,
  WidthState,
} from '@usitsdasdesign/dds-ng/shared';
import { IntakeConstant } from '../../intake/constants/intake.constant';
import { ProgressIndicatorService } from '../../common/services/progress-indicator.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SharedService } from '../../common/services/shared-service.service';
@Component({
  selector: 'app-export-pdf-popup',
  templateUrl: './export-pdf-popup.component.html',
  styleUrl: './export-pdf-popup.component.less',
})
export class ExportPdfPopupComponent implements OnDestroy {
  @Input() employeeId: number | null = null;
  submissionID: number | null = null;
  opportunityNumber!: string;
  unsubscriber$: Subject<void> = new Subject<void>();
  docMetaData: any;
  selectedDocumentIds: number[] = [];

  constructor(
    private readonly modalService: ModalService,
    private readonly submissionService: SubmissionService,
    private readonly documentService: DocumentService,
    private readonly submissioService: SubmissionService,
    private readonly progressIndicatorService: ProgressIndicatorService,
    private readonly sharedService: SharedService
  ) {}
  sampleColumns: Column[] = sampleColumns;
  docToShow: DocumentTableData[] = [];
  isAllSelected: boolean = false;
  selectedRowCount: number = 0;

  cancelButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primary,
    size: IntakeConstant.UI_ELEMENT_SIZE,
    width: WidthState.fixed,
    isLoading: false,
    isIconLeft: false,
    isColorBg: false,
    isInverse: false,
    disabled: true,
    customClass: '',
    role: 'button',
  };

  ngOnInit(): void {
    this.submissioService.currentSubmissionId$.subscribe((request) => {
      this.submissionID = request.submissionid;
      this.opportunityNumber = String(request.opportunitynumber);
    });
    this.loadDocumentTableData();
  }

  loadDocumentTableData(): void {
    this.submissionService
      .getDocumentTableData(+this.submissionID!)
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe({
        next: (data: any) => {
          this.docMetaData = data;
          this.docToShow = data;
          this.docToShow.forEach((item: any) => {
            item.selected = false;
          });
        },
        error: (err: HttpErrorResponse) => {
          console.error('An error occurred during fetching the data ', err);
        },
      });
  }

  toggleRow(rowData: DocumentTableData): void {
    rowData.selected = !rowData.selected;
    this.checkSelectedRow(this.docToShow);
  }

  selectAllRows(status: boolean, data: DocumentTableData[]): void {
    data.forEach((item) => (item.selected = status));
    this.checkSelectedRow(this.docToShow);
  }

  checkSelectedRow(data: DocumentTableData[]): void {
    this.selectedRowCount = data.filter((row) => row.selected).length;
    this.isAllSelected = data.length === this.selectedRowCount;
  }

  exportSelectedDocs(): void {
    this.progressIndicatorService.show();
    this.docToShow
      .filter((document) => document.selected)
      .forEach((document) =>
        this.selectedDocumentIds.push(document.submissionDocumentId)
      );

    let requestBody = {
      submissionid: this.submissionID,
      opportunitynumber: this.opportunityNumber,
      DocumentIds: this.selectedDocumentIds,
      EmployeeId: this.employeeId,
    };

    this.documentService.exportToPDF(requestBody, 'intake').subscribe({
      next: (response: string) => {
        if (response) {
          this.progressIndicatorService.hide();
          this.sharedService.showToastNotification(
            'Export in progress. Your download will start shortly.'
          );
          this.documentService.downloadPDFPolling(requestBody);
          this.close(true);
        }
      },
      error: (error: HttpErrorResponse) => {
        console.error('Download error:', error);
        this.progressIndicatorService.hide();
      },
    });
  }

  close(isConfirmed: boolean): void {
    this.modalService.close();
  }

  ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }
}
